<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/pro-light-svg-icons';

defineOptions({ inheritAttrs: false });

withDefaults(
  defineProps<{
    loading?: boolean;
    label?: string;
    icon?: IconDefinition;
    iconPos?: 'left' | 'right';
    iconRotation?: 90 | 180 | 270 | '90' | '180' | '270';
  }>(),
  {
    label: undefined,
    loading: false,
    icon: undefined,
    iconPos: 'left',
    iconRotation: undefined,
  },
);
</script>

<template>
  <p-button
    v-bind="$attrs"
    :pt="{ root: { 'data-test': $attrs['data-test'] } }"
    :pt:label:class="{ hidden: !label }"
    :pt-options="{ mergeProps: true }"
    :label
    :loading
    :icon-pos
  >
    <template #icon>
      <fa-icon
        v-if="icon"
        :icon
        :rotation="iconRotation"
        size="lg"
        data-test="button-icon"
        :class="`p-button-icon-${iconPos}`"
      />
    </template>

    <slot v-if="!loading" />
  </p-button>
</template>

<style scoped lang="scss">
  .p-button.p-button-transparent {
    background: transparent;
    border-color: transparent;
  }

  .p-button.p-button-transparent:hover {
    background: color-mix(in srgb, #FFF, transparent 85%);
    border-color: color-mix(in srgb, #FFF, transparent 85%);
  }

  .p-button.p-button-transparent:active {
    background: color-mix(in srgb, #FFF, transparent 60%);
    border-color: color-mix(in srgb, #FFF, transparent 60%);
  }

  .p-button.p-button-outlined {
    transition: background-color .35s linear;
  }

  .p-button.p-button-outlined:not(:disabled):hover {
    color: #FFF !important;
  }
</style>
